<template>
  <modal
    class="addNewRetainershipModal"
    name="addAAModal"
    transition="pop-out"
    :width="modalWidth"
    :height="500"
    @closed="closed"
    @opened="opened"
  >
    <div class="retainership__box">
      <button
        type="button"
        class="close modal-close"
        aria-label="Close"
        @click="closed"
      >
        <span aria-hidden="true">&times;</span>
      </button>
      <div class="text-center">
        <h3 class="mt-2 add__retainership__header">
          <span>
            <img src="@/assets/img/passage-of-time (1).png" width="50px" />
          </span>
          {{ $t("text.addAAModal.addAA") }}
        </h3>

        <div class="sign_up_form_section">
          <form>
            <!-- <div class="col-md-6"> -->
            <div class="mt-3 form_input_section">
              <div class="input__block" ref="phone_input_div">
                <input
                  type="email"
                  placeholder="Email"
                  class="form-control w-100"
                  v-model="email"
                />
              </div>
            </div>
            <!-- </div> -->

            <div class="mt-3 form_input_section">
              <div class="input__block" ref="phone_input_div">
                <input
                  type="text"
                  placeholder="Phone No"
                  class="form-control w-100"
                  v-model="phoneNumber"
                />
              </div>
            </div>

            <!-- <div class="mt-3">
              <label>Owner</label>
              <div class="input__block">
                <select v-model="ownerId">
                  <option selected disabled>Select Owner</option>
                  <option
                    :value="owner.id"
                    v-for="(owner, index) in companyBDList"
                    :key="index"
                  >
                    <span>
                      {{ owner.name }}
                    </span>
                  </option>
                </select>
              </div>
            </div> -->

            <div class="mt-3 form_input_section">
              <div class="mt-3 input__block">
                <select v-model="ownerId">
                  <option value="selectOwner" selected disabled>
                    {{ $t("text.addAAModal.selectOwner") }}
                  </option>
                  <option
                    :value="owner.id"
                    v-for="(owner, index) in companyBDList"
                    :key="index"
                  >
                    <span>
                      {{ owner.name }}
                    </span>
                  </option>
                </select>
              </div>
            </div>

            <div class="mt-3 form_input_section">
              <div class="mt-3 input__block">
                <select v-model="event">
                  <option value="selectEvent" selected disabled>
                    {{ $t("text.addAAModal.selectEvent") }}
                  </option>
                  <option
                    :value="event.id"
                    v-for="(event, index) in eventList"
                    :key="index"
                  >
                    <span>
                      {{ event.name }}
                    </span>
                  </option>
                </select>
              </div>
            </div>

            <div class="mt-5 text-center">
              <button
                class="btn dealers_btn"
                @click="addAA"
                :disabled="isButtonDisabled ? true : null"
                :style="[
                  isButtonDisabled
                    ? { cursor: 'not-allowed' }
                    : { cursor: 'pointer' },
                ]"
              >
                {{ $t("text.addAAModal.addAlertAlarm") }}
                <img
                  src="@/assets/img/git_loader.gif"
                  style="display: none"
                  width="19px"
                  class="ml-3 loader"
                />
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </modal>
</template>
<script>
const MODAL_WIDTH = 700;
import configObject from "@/config";
import JQuery from "jquery";
let $ = JQuery;

export default {
  name: "addAAModal",
  props: ["companyId"],
  data() {
    return {
      modalWidth: MODAL_WIDTH,
      isButtonDisabled: false,
      showLoader: false,
      email: "",
      phoneNumber: "",
      // companyId: "",
      ownerId: "selectOwner",
      event: "selectEvent",
      eventList: [],
      companyBDList: [],
      // companyList: [],
    };
  },
  // watch: {
  //   companyId(oldValue, newValue) {
  //     this.getCompanyBranchDealers();
  //   },
  // },
  // created() {
  //   this.modalWidth =
  //     window.innerWidth < MODAL_WIDTH ? MODAL_WIDTH / 2 : MODAL_WIDTH;
  // },
  methods: {
    opened() {
      this.getEvent();
      this.getCompanyBranchDealers();
      // this.getCompanies();
    },
    closed() {
      (this.email = null),
        (this.phoneNumber = null),
        (this.ownerId = null),
        (this.event = null),
        this.$modal.hide("addAAModal");
    },
    getEvent() {
      this.axios
        .get(
          `${configObject.apiBaseUrl}/event?target=Epump`,
          configObject.authConfig()
        )
        .then((response) => {
          this.eventList = response.data;
        })
        .catch((error) => {
          // this.showLoader = false;
        });
    },
    // getCompanies() {
    //   this.axios
    //     .get(
    //       `${configObject.apiBaseUrl}/company/getcompanies`,
    //       configObject.authConfig()
    //     )
    //     .then((response) => {
    //       this.companyList = response.data;
    //       console.log(response);
    //     })
    //     .catch((error) => {
    //       // this.showLoader = false;
    //     });
    // },
    getCompanyBranchDealers() {
      this.axios
        .get(
          `${configObject.apiBaseUrl}/company/getcompanybranchdealer/${this.companyId}`,
          configObject.authConfig()
        )
        .then((response) => {
          this.companyBDList = response.data;
          console.log(response);
        })
        .catch((error) => {
          // this.showLoader = false;
        });
    },
    addAA(event) {
      event.preventDefault();
      if (!this.ownerId) {
        this.$toast.open({
          message: this.$t("text.addAAModal.chooseOwner"),
          type: "error",
          duration: 3000,
        });
        return;
      }
      if (!this.event) {
        this.$toast.open({
          message: this.$t("text.addAAModal.chooseEvent"),
          type: "error",
          duration: 3000,
        });
        return;
      }
      if (!this.email) {
        this.$toast.open({
          message: this.$t("text.errors.emailMissing"),
          type: "error",
          duration: 3000,
        });
        return;
      }
      if (!this.phoneNumber) {
        this.$toast.open({
          message: this.$t("text.errors.inputPhoneNo"),
          type: "error",
          duration: 3000,
        });
        return;
      }

      const data = {
        email: this.email,
        phoneNumber: this.phoneNumber,
        ownerId: this.ownerId,
        companyId: this.companyId,
        eventId: this.event,
      };
      $(".loader").show();
      this.isButtonDisabled = true;

      this.axios
        .post(
          `${configObject.apiBaseUrl}/alertalarm`,
          data,
          configObject.authConfig()
        )
        .then((res) => {
          this.$toast.open({
            message: this.$t("text.addAAModal.aaAdded"),
            type: "success",
            duration: 3000,
          });
          // $(".loader").hide();
          // this.$toast("Successfully added AA", {
          //   type: "success",
          //   timeout: 3000,
          // });
          $(".loader").hide();
          this.isButtonDisabled = false;
          this.email = "";
          this.phoneNumber = "";
          this.ownerId = "";
          this.event = "";
          this.$modal.hide("addAAModal");
          this.$eventHub.$emit("getAA");
        })
        .catch((error) => {
          // this.isButtonDisabled = false;
          // $('.loader').hide();
          // this.$toast(error.response.data.message, {
          //     type: "error",
          //     timeout: 3000
          // });
        });
    },
  },
};
</script>
